<template>
    <div>
        <form @submit.prevent="onSubmit" id="code_form" class="kt-form disp-none">
            <vue-recaptcha
                v-if="captchaDriver === 'recaptcha'"
                ref="verifyCode"
                @verify="onVerify"
                @expired="onExpired"
                size="invisible"
                :sitekey="sitekey"
                :loadRecaptchaScript="true">
            </vue-recaptcha>
            
            <arcaptcha-vue
                v-if="captchaDriver === 'arcaptcha'"
                ref="arcaptchaVerify"
                :site_key="arCaptchaKey"
                :invisible="true"
                :callback="onArcaptchaSuccess"
                :expired_callback="onArcaptchaExpired"
                :error_callback="onArcaptchaError"
            />
            
            <kt-form-group>
                <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('auth.placeholder.code')"
                    name="code"
                    id="code"
                    :value="value"
                    @input="$emit('input', $event.target.value)"
                >
            </kt-form-group>
            <div class="kt-login__actions">
                <kt-button type="submit" id="verify_submit" variant="brand" class="btn-pill btn-elevate">
                    {{ $t('auth.btn.verify') }}
                </kt-button>
            </div>
            <div class="kt-login__account disp-none" id="resend_code_section">
                <span class="kt-login__account-msg">
                    {{ $t('auth.code_not_received') }}
                </span>&nbsp;&nbsp;
                <span id="resend_counter_div" class="kt-login__account-msg">
                    <span>
                        {{ $t('auth.title.resend_code_in') + ' ' }}
                    </span>
                    <span id="timer_span">60</span>
                    <span>
                        {{ ' ' + $t('auth.title.second') }}
                    </span>
                </span>
                <button type="button" class="btn p-0 m-0 make-hover disp-none" id="resend_btn" @click="resendCode">
                    {{ $t('auth.btn.resend') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import {authService} from "@/common/api.service";
import VueRecaptcha from "vue-recaptcha";
import { reCaptchaKeys } from '@/constants/getRecaptchaKey'
import { arCaptchaKeys } from '@/constants/getArCaptchaKey'
import { getCaptchaDriver } from '@/constants/getCaptchaDriver'
import ArcaptchaVue from 'arcaptcha-vue'

export default {
    name: "VerifyCode",
    props: ['phone', 'value'],
    data() {
        return {
            recaptcha_verified: false,
            g_recaptcha_response: "",
            sitekey: reCaptchaKeys,
            arCaptchaKey: arCaptchaKeys,
            captchaDriver: getCaptchaDriver,
            code: null,
            login_event: null,
            arcaptchaToken: '',
            arcaptchaVerified: false,
        }
    },

    components: { 
        VueRecaptcha,
        ArcaptchaVue 
    },

    methods: {
        onSubmit: function (e) {
            this.login_event = e;
            this.executeCaptcha();
        },
        
        executeCaptcha() {
            if (this.captchaDriver === 'recaptcha') {
                this.$refs.verifyCode.execute();
            } else if (this.captchaDriver === 'arcaptcha') {
                this.arcaptchaVerified = false;
                this.arcaptchaToken = '';
                this.$refs.arcaptchaVerify.execute();
            } else {
                this.verifyCode(this.login_event);
            }
        },
        
        // reCAPTCHA methods
        onVerify(response) {
            this.recaptcha_verified = true;
            this.g_recaptcha_response = response;
            this.verifyCode(this.login_event);
        },
        
        onExpired() {
            this.recaptcha_verified = false;
        },
        
        resetRecaptcha() {
            this.$refs.verifyCode && this.$refs.verifyCode.reset();
        },
        
        // Arcaptcha methods
        onArcaptchaSuccess(token) {
            this.arcaptchaToken = token;
            this.arcaptchaVerified = true;
            this.verifyCode(this.login_event);
        },
        
        onArcaptchaExpired() {
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
        },
        
        onArcaptchaError(error) {
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
            this.showMsg($('#code_form'), 'danger', 'Captcha verification failed. Please try again.');
        },
        
        resetArcaptcha() {
            this.$refs.arcaptchaVerify && this.$refs.arcaptchaVerify.reset();
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
        },
        
        isCaptchaVerified() {
            if (this.captchaDriver === 'recaptcha') {
                return this.recaptcha_verified;
            } else if (this.captchaDriver === 'arcaptcha') {
                return this.arcaptchaVerified && this.arcaptchaToken;
            }
            return true;
        },
        
        getCaptchaResponse() {
            if (this.captchaDriver === 'recaptcha') {
                return this.g_recaptcha_response;
            } else if (this.captchaDriver === 'arcaptcha') {
                return this.arcaptchaToken;
            }
            return '';
        },
        
        verifyCode() {
            let btn = $('#verify_submit')
            let form = $('#code_form')
            let change_pass = $('#change_pass')
            let before_code_verify = $('#before_code_verify')

            let params = {
                phone: this.phone,
                code: this.value,
            }

            // Add captcha response based on driver
            if (this.captchaDriver === 'recaptcha') {
                params['g-recaptcha-response'] = this.g_recaptcha_response;
            } else if (this.captchaDriver === 'arcaptcha') {
                params['g-recaptcha-response'] = this.arcaptchaToken;
            }

            form.validate({
                ignore: ".ignore",
                rules: {
                    code: {
                        required: true
                    },
                }
            })

            if (!form.valid()) {
                return;
            }

            if (!this.isCaptchaVerified()) {
                return;
            }

            KTApp.progress(btn)

            authService.verifyCode(params)
                .then(response => {
                    before_code_verify.addClass('disp-none')
                    change_pass.removeClass('disp-none')
                })
                .catch((error) => {
                    if (error.response.data.data)
                        form.validate().showErrors(error.response.data.data)
                    else
                        this.showMsg(form, 'danger', error.response.data.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                    if (this.captchaDriver === 'recaptcha') {
                        this.resetRecaptcha();
                    } else if (this.captchaDriver === 'arcaptcha') {
                        this.resetArcaptcha();
                    }
                })
        },
        
        resendCode() {
            this.$emit('resendCode')
        },
        
        showMsg(form, type, message) {
            // Implementation for showing messages
            console.log(`${type}: ${message}`);
        }
    }
}
</script>

<style scoped>
</style>